class ProductPersonalization extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.#handleChange);
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#handleChange);
  }

  #handleChange = (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;

    if (input.type === 'color') {
      const output = input.closest('[data-personalization-field]')?.querySelector('[data-color-output]');
      if (output) output.textContent = input.value.toUpperCase();
    }

    if (input.type !== 'file') return;

    const field = input.closest('[data-personalization-field]');
    const fileName = field?.querySelector('[data-file-name]');
    const originalFileName = field?.querySelector('[data-original-file-name]');
    const file = input.files?.[0];

    input.setCustomValidity('');
    if (file) {
      const maxFileMb = Number(input.dataset.maxFileMb || 10);
      if (file.size > maxFileMb * 1024 * 1024) {
        input.setCustomValidity(`Please choose a file smaller than ${maxFileMb} MB.`);
        input.reportValidity();
      }
    }

    if (fileName) fileName.textContent = file ? file.name : 'No file selected';
    if (originalFileName instanceof HTMLInputElement) originalFileName.value = file ? file.name : '';
  };
}

if (!customElements.get('product-personalization')) {
  customElements.define('product-personalization', ProductPersonalization);
}
